import Proxy from './Proxy';

class BoardProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/board', parameters);
  }

  /**
   * @returns {Promise}
   */
  getBoardMstInfo( boardNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}`);
  }

  getNoticeCount( boardNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/count`);
  }

  getArticleList( boardNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/list`);
  }

  confirmReadPwd( data ) {
    return this.submit('post', `/${this.endpoint}/${data.boardNo}/confirm-read`, data);
  }

  updateTemplate( boardNo, template ) {
    return this.submit('post', `/${this.endpoint}/${boardNo}/update-tempate`, {boardNo, template});
  }

  confirmUpdatePwd( data ) {
    return this.submit('post', `/${this.endpoint}/${data.boardNo}/confirm-update`, data);
  }

  removeArticle( boardNo, articleNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/remove/${articleNo}`);
  }

  unRemoveArticle( boardNo, articleNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/undo/${articleNo}`);
  }

  destroyArticle( boardNo, articleNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/destroy/${articleNo}`);
  }

  removeArticleChecked( boardNo, articleNoList ) {
    return this.submit('post', `/${this.endpoint}/${boardNo}/remove-checked`,{boardNo, articleNoList: JSON.stringify(articleNoList)});
  }

  unRemoveArticleChecked( boardNo, articleNoList ) {
    return this.submit('post', `/${this.endpoint}/${boardNo}/undo-checked`,{boardNo, articleNoList: JSON.stringify(articleNoList)});
  }

  destroyArticleChecked( boardNo, articleNoList ) {
    return this.submit('post', `/${this.endpoint}/${boardNo}/destroy-checked`,{boardNo, articleNoList: JSON.stringify(articleNoList)});
  }


  sendReplyMail( boardNo, articleNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/reply-mail/${articleNo}`);
  }

  getArticle( boardNo, articleNo ) {
    return this.submit('get', `/${this.endpoint}/${boardNo}/article/${articleNo}`)
    .then(res=>{

      if(res.item) {
        res.articleAttach.map(item=>item.name = item.fileNm)
        res.replyAttach.map(item=>item.name = item.fileNm)
      }  

      return res
    })
  }

  createArticle( data, fileList, removeAttachNoList ) {

    const formData = new FormData(); // 폼생성
    for(var key in data) {
      var value = data[key];
      if(value == undefined) {
        value = '';
      }
      formData.append(key, value);
    }
    // 첨부
    fileList.forEach(item=>  formData.append('file', item.raw ))
    // 삭제할 첨부번호
    removeAttachNoList.forEach(item=>  formData.append('removeAttachList', item ))

    return this.submit('post', `/${this.endpoint}/${data.boardNo}/article`, formData) ;

  }

  updateArticle( data, fileList, removeAttachNoList ) {

    const formData = new FormData(); // 폼생성
    for(var key in data) {
      var value = data[key];
      if(value == undefined) {
        value = '';
      }
      formData.append(key, value);
    }
    // 첨부
    fileList.forEach(item=>  formData.append('file', item.raw ))
    // 삭제할 첨부번호
    removeAttachNoList.forEach(item=>  formData.append('removeAttachList', item ))

    return this.submit('put', `/${this.endpoint}/${data.boardNo}/article/${data.articleNo}`, formData) ;

  }

  reply( data, fileList, removeAttachNoList ) {

    const formData = new FormData(); // 폼생성
    for(var key in data) {
      var value = data[key];
      if(value == undefined) {
        value = '';
      }
      formData.append(key, value);
    }
    // 첨부
    fileList.forEach(item=>  formData.append('file', item.raw ))
    // 삭제할 첨부번호
    removeAttachNoList.forEach(item=>  formData.append('removeAttachList', item ))

    return this.submit('put', `/${this.endpoint}/${data.boardNo}/reply/${data.articleNo}`, formData) ;

  }

}

export default BoardProxy;
